import React from 'react';
import SalesmanTable from '../../../components/UserMasters/Salesman/SalesmanTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <SalesmanTable />
        </ContentView>
    );
};
export default index;
